import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { AuthContext } from '../context/auth';

// redirect user to the home page if they are logged in.
const AuthRoute = ({ component: Component, ...rest }) => {
  const { user } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={props =>
        user ? <Redirect to='/' /> : <Component {...props} />
      }
    />
  );
}

export default AuthRoute;
